import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatComponent } from './chat/chat.component';
import { HomeComponent } from './home/home.component';

export const routes: Routes = [
    { path: 'chat', component: ChatComponent },
    { path: 'home', component: HomeComponent, title: 'ROAR Web Chat' },
    { path: ':organizationId/:conversationId/:joinCode/:anything', component: ChatComponent},
    { path: ':organizationId/:conversationId/:joinCode/**', component: ChatComponent},
    { path: ':organizationId/:conversationId/:joinCode', component: ChatComponent},
    { path: '', component: HomeComponent, title: 'ROAR Web Chat' },
    { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }